// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-container{
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  color: #FFFFFF;
}
.toast-text {
  color: #9B5CFD;
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
}

/* common toast message background added */
.Toastify__toast-theme--light, 
.Toastify__toast-theme--colored.Toastify__toast--default {
    background-color: #1E2242 !important;
    color: #E9E8F2 !important;
}
.Toastify__close-button--light{
    color: #E9E8F2 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Toast/CommonToast.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;;IAEI,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B","sourcesContent":[".toast-container{\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  border-radius: 8px;\n  color: #FFFFFF;\n}\n.toast-text {\n  color: #9B5CFD;\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n/* common toast message background added */\n.Toastify__toast-theme--light, \n.Toastify__toast-theme--colored.Toastify__toast--default {\n    background-color: #1E2242 !important;\n    color: #E9E8F2 !important;\n}\n.Toastify__close-button--light{\n    color: #E9E8F2 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
